if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        if (this.form.querySelector('[name=id]')) {
          this.form.querySelector('[name=id]').disabled = false;
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.sizeSwatch = this.querySelectorAll('input[data-quick-add="true"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        if (this.sizeSwatch) {
          this.sizeSwatch.forEach((el) => {
            el.addEventListener('click', () => setTimeout(() => this.submitButton.click(), 1000));
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').removeAttribute('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            this.cart.renderContents(response);
            sendAddToCartAnalytics(response);
            console.log(response);

            this.submitButton.querySelector('span').textContent = 'Added to Cart';

            setTimeout(() => {
              this.submitButton.querySelector('span').textContent = 'Add to Cart';
            }, 3000)
            if (this.closest('.product-card')) {
              this.closest('.product-card').classList.add('item-added');
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').setAttribute('hidden', '');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

async function sendAddToCartAnalytics(response) {
  const product = {
    ProductID: response.product_id,
    VariantID: response.variant_id,
    Name: response.product_title,
    VariantName: response.variant_title,
    Price: response.price / 100,
    Quantity: response.quantity,
    Categories: [response.product_type || 'Stereo Consoles'],
    ImageURL: response.image,
    URL: `https://${window.location.host}${response.url}`,
    Brand: response.vendor || 'Wrensilva Shop'
  };

  let cart_id = window.ShopifyAnalytics?.meta?.cartToken;
  if (!cart_id) {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      cart_id = data.token;
    } catch (e) {
      console.warn('Cart token fetch failed:', e);
    }
  }

  if (window._learnq) {
    const klaviyoPayload = {
      Name: product.Name,
      ProductID: product.ProductID,
      VariantID: product.VariantID,
      Finish: product.VariantName,
      Categories: product.Categories,
      ImageUrl: product.ImageURL,
      Url: product.URL,
      Brand: product.Brand,
      Price: product.Price,
      $use_ip: true,
      $is_session_activity: true
    };

    console.log('[Klaviyo] Added To Cart payload:', klaviyoPayload);
    _learnq.push(['track', 'Added To Cart', klaviyoPayload]);
  }
}
